import React from "react";
import { FaSearch, FaUserCircle } from "react-icons/fa";
import { IoIosArrowRoundBack } from "react-icons/io";
import { BiRefresh } from "react-icons/bi";

import { IoNotificationsSharp, IoMenu } from "react-icons/io5";
import Input from "../components/Input";
import Breadcrumbs from "../components/Breadcrumbs";
import { Button, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";

function Header(props) {
  const { onMenuClick, name, onForceRefresh, isLoading } = props;

  const navigate = useNavigate();
  const handleBackButton = () => {
    navigate(-1);
  };
  return (
    <div className="flex flex-col sm:flex-row w-full">
      <div className="py-2 px-4 w-full ">
        <div className="flex items-center font-light text-sm ">
          <IconButton onClick={handleBackButton}>
            <IoIosArrowRoundBack size={32} />
          </IconButton>
          <Breadcrumbs className="flex-grow" />
          <div className="sm:hidden">
            <IconButton onClick={onMenuClick}>
              <IoMenu size={24} />
            </IconButton>
          </div>
        </div>
        <div className="flex items-center px-4 text-primary ">
          <div className="text-lg font-bold flex-grow">{name}</div>
          <IconButton
            onClick={(e) => {
              if (e.ctrlKey) {
                window.location.reload();
              } else {
                onForceRefresh(e);
              }
            }}
            className={isLoading ? "animate-spin" : ""}
          >
            <BiRefresh />
          </IconButton>
        </div>
      </div>

      <div className="items-center flex mx-4">
        <div>
          <IconButton
            onClick={() => {
              navigate("/dashboard/admin-notifications");
            }}
          >
            <IoNotificationsSharp size={20} className="cursor-pointer mr-3" />
          </IconButton>
        </div>
      </div>

      {/* <div className="items-center flex ">
        <Input
          placeholder="Type here..."
          icon={<FaSearch />}
          className="mr-3 flex-grow invisible"
        />
        <IoMenu
          size={20}
          className="cursor-pointer visible sm:invisible mx-4"
          onClick={() => setNav(true)}
        />
        <FaUserCircle size={20} className="mr-3 cursor-pointer hidden" />
        <IoNotificationsSharp
          size={20}
          className="cursor-pointer mr-3 hidden"
        />
      </div> */}
    </div>
  );
}

export default Header;
